export default __webpack_public_path__ + "static/media/cancel_icon.c9c75401.svg";